<div class="bmc-tree-node" *ngFor="let item of itemsTree" >
  <div class="bmc-tree-node__item bmc-flex" [class.selected]="isSelected(item)" (click)="selectItem(item)" >
    <div style="display: inline-block;">
      <svg class="bmc-tree-node__arrow" *ngIf="item.nodes.length > 0">
        <use *ngIf="!item.isExpanded" href="#icon-arrow-right-bold"></use>
        <use *ngIf="item.isExpanded" href="#icon-arrow-down-bold"></use>
      </svg>
    </div>
    <span class="bmc-tree-node__text bmc-display-block" >{{item.displayName}}</span>
  </div>
  <div *ngIf="item.nodes && item.isExpanded">
    <connect-provider-tree class="bmc-tree-node__sublist" [itemsTree]="item.nodes" [currentItemSelected]="currentItemSelected" (selectedItem)="selectItem($event)"></connect-provider-tree>
  </div>
</div>

